var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.405,
    height: 9.404,
    viewBox: "0 0 9.405 9.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11209",
    "data-name": "Path 11209",
    d: "M14.316,10.411l-.052-.094a1.567,1.567,0,0,1,0-1.191L14.316,9a1.571,1.571,0,0,0-.846-2.047L13.355,6.9a1.53,1.53,0,0,1-.846-.846l-.042-.1A1.592,1.592,0,0,0,10.409,5.1l-.1.042a1.594,1.594,0,0,1-1.2,0L9.009,5.1a1.577,1.577,0,0,0-2.037.857l-.042.084a1.53,1.53,0,0,1-.846.846l-.094.042A1.575,1.575,0,0,0,5.155,8.98l.042.094a1.567,1.567,0,0,1,0,1.191l-.042.115A1.548,1.548,0,0,0,6,12.417l.1.042a1.53,1.53,0,0,1,.846.846L7,13.42a1.561,1.561,0,0,0,2.037.857l.115-.052a1.594,1.594,0,0,1,1.2,0l.094.042A1.571,1.571,0,0,0,12.5,13.42l.042-.084a1.53,1.53,0,0,1,.846-.846l.084-.031A1.559,1.559,0,0,0,14.316,10.411ZM9.291,11.727,7.254,10.014l.627-.742,1.3,1.1,2.288-2.716.742.627Z",
    transform: "translate(-5.033 -4.988)",
    fill: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.fb80d67d5495f4143d9cd3b2f5218288.svg";
export { ForwardRef as ReactComponent };